import React from 'react';
import { Form, Container, Row, Col } from 'react-bootstrap';
import { firebase, uniqueID, sanitizeEmail } from "../Database/firebase";
import stonkVid from '../Assets/Videos/Stonk.mp4';
import "../App.css";

function StonkDownloadView() {
    const entry_style = {
        color: 'White',
        backgroundColor: '#0f0f0f',
        borderRadius: 1000,
        borderColor: '#0f0f0f',
        height: '55px',
        fontFamily: "Inter-Regular"
    }

    function goToAppStore(e) {
        e.preventDefault();
        window.open('https://apps.apple.com/us/app/stonk/id1558279818', '_blank');
    }

    function handleSubmit(e) {
        e.preventDefault();
        goToAppStore(e);

        var uid = uniqueID();
        const email = e.target.email.value;
        const sanitizedEmail = sanitizeEmail(email);

        if (sanitizedEmail !== "") {
            firebase.database().ref('ReferredEmailsFromWeb/OutgoingMail/' + uid + "/").set({
                Email: sanitizedEmail
            }).then(function () {
                // Success
            });
        }
    }

    return (
        <Container className="inski-card">
            <Row className="align-items-center">
                <Col md={7} className="mb-4 mb-md-0">
                    <div className="video-wrapper" style={{ borderRadius: '15px', overflow: 'hidden', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
                        <video autoPlay loop muted playsInline controls style={{ width: '100%', display: 'block' }}>
                            <source src={stonkVid} type='video/mp4' />
                        </video>
                    </div>
                </Col>
                <Col md={5}>
                    <div style={{ textAlign: 'left', paddingLeft: '20px' }}>
                        <h1 style={{ fontFamily: "Inter-SemiBold", marginBottom: '1rem' }}>
                            Join the Stonk Community!
                        </h1>
                        <p style={{ fontFamily: "Inter-Regular", color: 'GrayText', marginBottom: '2rem' }}>
                            With over 500 users Stonk allows them to build watchlists with their friends, track future investments together, join communities dedicated to the stocks you love, and so much more! Join today by downloading Stonk on the Apple AppStore!
                        </p>

                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label style={{ color: 'Black', fontFamily: "Inter-Regular" }}>
                                    Refer a friend to join with you! <span style={{ color: 'GrayText', fontFamily: "Inter-Regular", fontSize: "12px" }}>(optional)</span>
                                </Form.Label>

                                <Form.Control type="Email" id="email" placeholder="invite-your-friends@gmail.com" style={entry_style} />

                                <Form.Text className="text-muted" style={{ fontFamily: "Inter-Regular" }}>
                                    * If the field above has a valid email address and you press 'Download on Apple' a one-time email will be sent providing information to download Stonk.
                                </Form.Text>
                            </Form.Group>
                            <button className='downloadButton' type="submit">
                                Download on Apple
                            </button>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default StonkDownloadView;
